import { useEffect } from "react";

import { useExactOrDefaultVehicleVisualModel } from "@/common/hooks/entity/vehicleVisualModel/useExactOrDefaultVehicleVisualModel";
import {
  VehicleBodyType,
  VehicleType,
  VehicleVisualModelDto,
  VehicleVisualModelType,
} from "@/core/api/generated/v1";

interface Props {
  /** Id that is currently selected. */
  visualModelId: Nil<string>;
  filters: {
    type?: VehicleVisualModelType | null;
    vehicleType?: VehicleType;
    bodyType?: VehicleBodyType | null;
    vehicleId?: string | null;
  };

  onChange?: (newValue: Nil<VehicleVisualModelDto>) => void;
}

/** Automatically selects exact or suggested visual model. */
export default function VehicleVisualModelAutoSelector({
  visualModelId,
  filters,
  onChange,
}: Props) {
  const result = useExactOrDefaultVehicleVisualModel({
    visualModelId,
    defaultModelFilters: filters,
  });

  useEffect(() => {
    if (visualModelId) {
      onChange && onChange(result.visualModelExact);
    } else {
      onChange && onChange(result.visualModelDefault);
    }
  }, [result.visualModelExact, result.visualModelDefault]);

  return null;
}
